import { cdnImages } from "../../utils/imageMap.cdn";
import { Heading } from "../ui/Heading/Heading";

// Sample logo data
const logos = cdnImages.logos;
const Client = () => {
  return (
    <div className="flex flex-col justify-center items-center h-[30vh] w-full gap-8">
      <Heading placeholder="Trusted By" />
      <div className="flex justify-center items-center lg:gap-20 md:gap-15 sm:gap-10 gap-5 w-full lg:h-full px-4">
        {Object.entries(logos || {})
          .slice(0, 6)
          .map(([key, src]) => (
            <div className=" lg:w-[100px] flex justify-center" key={key}>
              <img src={src} alt={key} className="object-contain" />
            </div>
          ))}
      </div>
    </div>
  );
};

export default Client;
